<template>
  <div class="coupon-input" :class="{ 'coupon-input--expanded': isActive }">
    <div class="coupon-input__header" @click="toggleActive">
      <div class="coupon-input__title">
        <span v-if="!isApplied" class="coupon-input__title-text"
          >Add a promocode</span
        >
        <span v-else class="coupon-input__title-text"
          >Promocode ‘<strong>{{ inputValue }}</strong
          >’ is applied</span
        >
      </div>
      <img v-if="isActive" src="@/assets/icons/dash.svg" alt="dash-icon" />
      <img
        v-if="!isActive"
        src="@/assets/icons/plus-dark.svg"
        alt="plus-dark-icon"
      />
    </div>
    <transition name="fade">
      <div v-if="isActive" class="coupon-input__input-container">
        <b-form-input
          v-model="inputValue"
          class="coupon-input__input"
          :disabled="isApplied"
          @input="handleInput"
        />
        <b-button
          v-if="!isApplied"
          class="coupon-input__button"
          @click="applyDiscount"
          >Apply</b-button
        >
        <b-button
          v-if="isApplied"
          class="coupon-input__button"
          @click="removeDiscount"
          >Remove</b-button
        >
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PromoCodeInput',

  props: {
    value: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isApplied: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },

  methods: {
    toggleActive() {
      this.$emit('switchPromocodeInput');
    },
    removeCoupon() {
      this.inputValue = '';
      this.$emit('switchPromocodeInput');
    },
    handleInput(value) {
      this.$emit('input', value);
    },
    applyDiscount() {
      this.$emit('onApplyDiscount');
    },
    removeDiscount() {
      this.$emit('onRemoveDiscount');
    }
  }
};
</script>

<style scoped lang="scss">
.coupon-input {
  background-color: $light-grey-color;
  padding: 10px 16px;
  cursor: pointer;

  @media (max-width: $screen-width-lg) {
    margin-bottom: 24px;
  }

  &--expanded {
    background-color: $light-grey-color;
    padding-bottom: 16px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    display: flex;
    align-items: center;
  }

  &__title-text {
    margin-right: 10px;
  }

  &__input {
    border-radius: 8px;
    height: 48px;
  }

  &__input-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  &__button {
    height: 48px;
    margin-left: 10px;
    border-radius: 10px;
    background: $primary-color;
    color: $dark-color;
    border-color: $primary-color;
  }
}
</style>
